import PropTypes from 'prop-types';
import { forwardRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
// @mui
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import { useResponsive } from 'src/hooks/use-responsive';
// routes
import { RouterLink } from 'src/routes/components';

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, variant = 'lightBg', sx, ...other }, ref) => {
  const user = useSelector((state) => state.user?.user);
  const lastActiveCompanyValue = user?.lastActiveCompany;
  const activeCompanyId =
    typeof lastActiveCompanyValue === 'string'
      ? lastActiveCompanyValue
      : lastActiveCompanyValue?._id;
  const activeCompanyFromList = user?.companies?.find(
    (company) => company?.companyId?._id === activeCompanyId
  )?.companyId;
  const activeCompany =
    typeof lastActiveCompanyValue === 'object' && lastActiveCompanyValue !== null
      ? lastActiveCompanyValue
      : activeCompanyFromList;
  const isSubAccount = Boolean(
    user?.subAccount ??
      user?.isSubAccount ??
      activeCompany?.subAccount ??
      activeCompany?.isSubAccount
  );

  const darkVariantLogo = isSubAccount
    ? '/logo/studly_new_branding_for_sub_accounts.svg'
    : '/logo/studly_new_branding_exact.svg';
  const lightVariantLogo = isSubAccount
    ? '/logo/studly_new_branding_for_sub_accounts_for_white_backgrounds.svg'
    : '/logo/studly_new_branding_exact_for_white_backgrounds.svg';
  const logoSrc = variant === 'darkBg' ? darkVariantLogo : lightVariantLogo;

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      console.debug('[Logo] variant selected', {
        variant,
        isSubAccount,
        logoSrc,
      });
    }
  }, [variant, isSubAccount, logoSrc]);

  // Logo component
  const logo = (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <Box
        component="img"
        src={logoSrc}
        sx={{
          cursor: 'pointer',
          height: 'auto',
          maxHeight: { xs: 60, lg: 80 },
          width: 'max-content',
          mx: 'auto',
          ...sx,
        }}
      />
    </Box>
  );

  if (disabledLink) {
    return logo;
  }

  return (
    <Link component={RouterLink} href="/" sx={{ display: 'contents' }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
  variant: PropTypes.oneOf(['lightBg', 'darkBg']),
};

export default Logo;
